import React, { useEffect, useState, useCallback } from 'react';
import { formatCurrency } from '../../tools/tool';

const ProfitOrdersCard = ({ dateRange }) => {
  const [totalTransfers, setTotalTransfers] = useState(0);
  const [pendingTransfers, setPendingTransfers] = useState(0);
  const [completedTransfers, setCompletedTransfers] = useState(0);

  const getTransferData = useCallback(async () => {
    setTotalTransfers(0);
    setPendingTransfers(0);
    setCompletedTransfers(0);
  }, []);

  useEffect(() => {
    getTransferData();
  }, [getTransferData, dateRange]);

  return (
    <div className="card" style={{ 
      width: '100%',
      marginBottom: '20px',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
        <div className="card-header" style={{ 
          backgroundColor: '#f8f9fa', 
          borderBottom: '1px solid #e0e0e0',
          padding: '15px',
          textAlign: 'center'
        }}>
          <h5 style={{ margin: 0, color: '#333', fontWeight: 'bold' }}>PROFIT FROM ORDERS</h5>
          <p style={{ color: '#666', fontSize: '14px', margin: 0}}>
            Total Sales Income from PDL Order
          </p>
        </div>
      <div className="card-body" style={{ padding: '20px' }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <h2 style={{ 
            fontSize: '2rem', 
            fontWeight: 'bold', 
            color: '#333',
            margin: 0
          }}>
              {formatCurrency(totalTransfers || 0)}
          </h2>
          <p style={{ color: '#666', fontSize: '14px', margin: 0}}>
            Sales Order - Purchase Order = Profit from Orders
          </p>
        </div>
        
      </div>
    </div>
  );
};

export default ProfitOrdersCard;
